import React from 'react';
import Select from 'react-select';
import AdminValueContainer from '../filters/react-select-custom-child-components/AdminValueContainer';
import { ChevronDown } from '../filters/react-select-custom-child-components/DropdownHelpers';

export interface SortByItem {
  label: string,
  value: string,
}

export interface SortByProps {
  items: SortByItem[],
  currentSort: SortByItem,
  setCurrentSort: (sort: SortByItem, key: string) => void,
  sortKey: string,
  wrapperClass?: string,
}

const SimpleSortBy: React.FC<SortByProps> = ({
  items,
  currentSort,
  setCurrentSort,
  sortKey,
  wrapperClass = '',
}) => {
  return (
    <Select
      isClearable={false}
      aria-label="Sort By"
      className={`algolia-select btn btn-outline-light border-border-grey button-shadow text-dark-btn-txt align-items-center ${wrapperClass}`}
      classNamePrefix="algolia-select"
      value={currentSort}
      components={{
        ValueContainer: AdminValueContainer,
        DropdownIndicator: ChevronDown,
        IndicatorSeparator: () => null,
      }}
      onChange={(item) => item && setCurrentSort(item, sortKey)}
      isSearchable={false}
      options={items}
      placeholder={currentSort}
    />
  );
};

export default SimpleSortBy;
